export default __webpack_public_path__ + "static/sociomeconal-shape-6e14501b6e31bb4c185671c85e50fca1.png";